/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

function CancelButton({
  children = "Cancelar",
  onClick,
  disabled = false,
  fullWidth = false,
  sx,
  ...rest
}) {
  return (
    <Button
      variant="outlined"
      color="secondary"
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      sx={{
        height: 48,
        color: "#344767",
        borderColor: "#344767",
        backgroundColor: "#fff",
        "&:hover": {
          borderColor: "#344767",
          backgroundColor: "#f5f6f8",
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}

CancelButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  sx: PropTypes.object,
};

export default CancelButton;
